let configurazione = {
    urlBackend: "https://relazioni-ambiente-priv-test.regione.liguria.it/api/",
    urlApplicativo: "https://relazioni-ambiente-priv-test.regione.liguria.it/",
    token: "",
    deployContext: "TEST ANTEPRIMA",
    pathRadice: "relazioneStatoAmbiente",
    tipoAmbiente: "FO"
}

export default configurazione;